import React from "react";
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button";
import GenericDialog from "../../../../components/ui/dialogs/generic-dialog/GenericDialog";
import {withRouter} from "react-router-dom";
import PropTypes from "prop-types";

const RichiestaInviataDialog = (props) => {

    const dialogContent = (
        <React.Fragment>
            <Typography variant={"body2"}>{props.bodyText}</Typography>
        </React.Fragment>
    );

    const handleRichiesteAssistenzaButton = () => {
        props.history.push(`/mobile/assistenza`);
        props.handleDialogClose();
    }

    const dialogActions = (
        <React.Fragment>
            <Button autoFocus onClick={handleRichiesteAssistenzaButton} color="secondary" variant="text">
                Richieste e assistenza
            </Button>
            <Button autoFocus
                    onClick={props.handleDialogClose}
                    color="primary"
                    variant="contained"
            >
                Chiudi
            </Button>
        </React.Fragment>
    );

    return (
        <GenericDialog
            dialogWidth="xs"
            open={props.open}
            handleDialogClose={props.handleDialogClose}
            handleDialogCloseButton={props.handleRichiestaCloseButton}
            dialogActions={dialogActions}
            dialogContent={dialogContent}
        >
            <Typography variant={"h6"}>{props.titleText}</Typography>
        </GenericDialog>
    )
}

RichiestaInviataDialog.propTypes = {
    titleText: PropTypes.string,
    bodyText: PropTypes.string
};

RichiestaInviataDialog.defaultProps = {
    titleText: "Richiesta inviata",
    bodyText: "La richiesta è stata inviata correttamente. Verrai contattato dal Servizio Clienti quanto prima. Puoi vedere le tue richieste aperte nella sezione Richieste e Assistenza"
}

export default withRouter(RichiestaInviataDialog);
